export const GET_FIRM_STATISTICS_STRUCTURE = "GET_FIRM_STATISTICS_STRUCTURE";
export const GET_RENEWAL_TRACKING_STRUCTURE = "GET_RENEWAL_TRACKING_STRUCTURE";
export const GET_APPLICATION_SUMMARY_STRUCTURE = "GET_APPLICATION_SUMMARY_STRUCTURE";
export const GET_LENDER_TRANSACTION_STRUCTURE = "GET_LENDER_TRANSACTION_STRUCTURE";
export const GET_COMMISSIONS_STRUCTURE = "GET_COMMISSIONS_STRUCTURE";
export const GET_RISK_LEVEL_STRUCTURE = "GET_RISK_LEVEL_STRUCTURE";
export const GET_REPORTS_HISTORY_LOADING_STATE = "GET_REPORTS_HISTORY_LOADING_STATE";
const getters = {
  [GET_FIRM_STATISTICS_STRUCTURE]: state => {
    return state.firmStatisticsStructure;
  },
  [GET_RENEWAL_TRACKING_STRUCTURE]: state => {
    return state.renewalTrackingStructure;
  },
  [GET_APPLICATION_SUMMARY_STRUCTURE]: state => {
    return state.applicationSummaryStructure;
  },
  [GET_LENDER_TRANSACTION_STRUCTURE]: state => {
    return state.lenderTransactionStructure;
  },
  [GET_COMMISSIONS_STRUCTURE]: state => {
    return state.commissionsStructure;
  },
  [GET_RISK_LEVEL_STRUCTURE]: state => {
    return state.riskLevelStructure;
  },
  [GET_REPORTS_HISTORY_LOADING_STATE]: state => {
    return state.reportsHistoryLoader;
  }
};
export default getters;